import React, { useState } from "react";
import Input from "../../core/design-system/Input/Input";
import Selector from "../../core/design-system/dropdown/Selector";
import TextArea from "../../core/design-system/TextArea";
import Button from "../../core/design-system/Button/Button";
import {
  fetchBeneficiaries,
  transferFunds,
} from "../../../network/Apiservices";
import {
  AccountOptionType,
  AccountType,
  beneficiaryType,
  mfaPayloadType,
  transferFormType,
} from "../types";
import SelectDevice from "../../core/components/SelectDevice";
import ApproveTransaction from "../../core/components/ApproveTransfer.tsx";
import ResultModal from "../../core/components/ResultModal";
import { transferWeights, typeOptions } from "../../../constants/config";
import Countries from "../../../assets/raw/countries.json";
import { useSelector } from "react-redux";
import {
  selectAccount,
  selectPortFolio,
} from "../../dashboard/redux/accountSlice";
import TransferDetails from "./TransferDetails";
import { validatePayload } from "../../auth/utils/utility";
import { useLocationContext } from "../../location/context/locationContext";
import { getCurrentCurrency } from "../../../utils/currencyFormatter";

interface FundTransferFormProps {
  // Define your prop types here
}

const defaultState: transferFormType = {
  isDeviceListModelOpen: false,
  isAppoveModelOpen: false,
  isResultModalOpen: false,
  otp: "",
  isManual: false,
  haveAccountsOptions: [],
  toAccountOptions: [],
  toCountry: null,
  showStotpModal: false,
  mfaPayload: undefined,
  narration: "",
  transactionType: "",
  amount: "",
  beneficiary: null,
  showBeneficiarySelector: false,
  payees: [],
  benefeciaries: [],
  accountsHave: [],
  accountsOwe: [],
  approvalStatus: null,
  toAccount: null,
  completedTransactionId: "",
};

const FundTransferForm: React.FC<FundTransferFormProps> = (props) => {
  const account = useSelector(selectAccount);
  const [state, setState] = useState(defaultState);
  const [mfaPayload, setMfaPayload] = useState<mfaPayloadType | null>(null);
  const portFolio = useSelector(selectPortFolio);
  const { locationData } = useLocationContext();

  const toggleDeviceList = () => {
    console.log("toggleDeviceList", !state.isDeviceListModelOpen);
    setState({
      ...state,
      isDeviceListModelOpen: !state.isDeviceListModelOpen,
    });
  };

  const toggleApprove = () => {
    setState({
      ...state,

      isAppoveModelOpen: !state.isAppoveModelOpen,
    });
  };

  const toggleResultModal = () => {
    setState({
      ...state,
      isResultModalOpen: !state.isResultModalOpen,
    });
  };

  const navigateToApproveModal = () => {
    setState({
      ...state,
      isAppoveModelOpen: true,
      isResultModalOpen: false,
      isDeviceListModelOpen: false,
    });
  };

  const setStatus = (status: transferFormType["approvalStatus"]) => {
    setState({
      ...state,
      isAppoveModelOpen: false,
      isResultModalOpen: true,
      isDeviceListModelOpen: false,
      approvalStatus: status,
    });
  };

  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload = {
      transferType: state.transactionType,
      fromAccount: account?.value.id,
      toAccount: state.toAccount?.value.id,
      amount: `${state.amount}`,
      fromCurrency: getCurrentCurrency().code,
      toCurrency: getCurrentCurrency().code,
      narration: state.narration,
      beneficiaryId: state.beneficiary?.value.id,
      payeeName: state.toAccount?.value.name || state.beneficiary?.value.name,
      toCountry:
        state.transactionType === "INTERNATIONAL_TRANSFER"
          ? state.toCountry.code
          : undefined,
      swiftCode:
        state.transactionType === "INTERNATIONAL_TRANSFER"
          ? state.toCountry.swiftCodePrefix
          : undefined,
      sourceOfFunds:
        state.transactionType === "INTERNATIONAL_TRANSFER"
          ? state.narration
          : undefined,
    };
    const isValidPayload = validatePayload(payload);
    if (!isValidPayload) {
      return;
    }
    try {
      const res = await transferFunds(
        state.transactionType,
        payload,
        undefined,
        locationData
      );
      let weight = JSON.parse(res.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]).weight;

      setMfaPayload(JSON.parse(res.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]));

      const isManual =
        weight === transferWeights.ST_LOWRISK_TOTP ||
        weight === transferWeights.ST_HIGHRISK_TOTP;

      setState({
        ...state,
        isAppoveModelOpen: true,
        isManual: isManual,
      });
    } catch (error: any) {
      console.log("error", error);
    }
  };

  const onSelectType = async (e: any) => {
    let haveAccountsOptions = portFolio.youHaveAccounts.map(
      (d: AccountType) => {
        return { label: d.name, value: d };
      }
    );
    if (e.value === "OWN_ACCOUNT_TRANSFER") {
      let toAccounts = haveAccountsOptions.filter(
        (d: AccountOptionType) => d.value.id !== account?.value.id
      );
      setState({
        ...state,
        transactionType: e.value,
        toAccountOptions: toAccounts,
        haveAccountsOptions,
      });
      return;
    }
    if (e.value !== "OWN_ACCOUNT_TRANSFER") {
      let res = await fetchBeneficiaries(e.value);
      let payees = res.beneficiaries.map((d: beneficiaryType) => {
        return { label: d.name, value: d };
      });

      console.log("state.haveAccountsOptions", state.haveAccountsOptions);

      console.log(state, "STATE");

      setState({
        ...state,
        transactionType: e.value,
        haveAccountsOptions,
        payees,
      });
      return;
    } else {
      return;
    }
  };

  const onChangeAmount = (e: any) => {
    const regex = /^[0-9()-]+$/;
    if (!regex.test(e.target.value)) {
      return;
    } else setState({ ...state, amount: e.target.value });
  };

  const onChangeNote = (e: any) => {
    setState({ ...state, narration: e });
  };

  const onSelectToAccount = (e: any) => {
    setState({ ...state, toAccount: e });
  };

  const onSelectPayee = (e: any) => {
    setState({ ...state, beneficiary: e.value, toAccount: null });
  };

  const onSelectCountry = (e: any) => {
    console.log("onSelectCountry", e.value);
    setState({ ...state, toCountry: e.value });
  };

  return (
    <div className="flex flex-col bg-gray p-3 rounded-xl w-100 border border-lightGray bg-gray-100_01 h-full">
      <div className="flex flex-col flex-[1] gap-8 bg-white p-3 rounded-xl bg-white-A700">
        <div className="flex flex-col ">
          <p className="xs:text-lg xs:font-medium 5xl:text-xl 5xl:font-normal text-left">
            Fund Transfer
          </p>
          <p className="xs:text-sm xs:font-medium 5xl:text-lg 5xl:font-normal text-blue_gray-500 text-left ">
            Enter payee name or select payee to transfer amount
          </p>
        </div>

        <form
          className="flex flex-col gap-1 justify-between flex-[1]"
          onSubmit={submitHandler}
        >
          <div className="flex flex-col mb-4">
            <label
              htmlFor="payee"
              className="xs:text-xs 5xl:text-lg font-normal  text-gray-50_04 text-left mb-2"
            >
              Select Transfer Type
            </label>
            <Selector
              shape="round"
              onChange={onSelectType}
              options={typeOptions}
            />
          </div>

          {state.transactionType === "OWN_ACCOUNT_TRANSFER" ? (
            <div className="flex flex-col mb-4">
              <label
                htmlFor="payee"
                className="xs:text-xs 5xl:text-lg text-gray-50_04 text-left mb-2"
              >
                Select To Account
              </label>
              <Selector
                shape="round"
                onChange={onSelectToAccount}
                options={state.toAccountOptions}
              />
            </div>
          ) : (
            <div className="flex flex-col mb-4">
              <label
                htmlFor="payee"
                className="xs:text-xs 5xl:text-lg text-gray-50_04 text-left mb-2"
              >
                Select Payee
              </label>
              <Selector
                shape="round"
                onChange={onSelectPayee}
                options={state.payees}
              />
            </div>
          )}

          {state.transactionType === "INTERNATIONAL_TRANSFER" && (
            <div className="flex flex-col mb-4">
              <label
                htmlFor="payee"
                className="xs:text-xs 5xl:text-lg text-gray-50_04 text-left mb-2"
              >
                Select Country
              </label>
              <Selector
                shape="round"
                onChange={onSelectCountry}
                options={Countries.countries}
              />
            </div>
          )}
          <div className="flex flex-col mb-4">
            <label
              htmlFor="payee"
              className="xs:text-xs 5xl:text-lg  text-gray-50_04 text-left mb-2"
            >
              Transfer Amount
            </label>
            <Input
              label={getCurrentCurrency().code}
              onChange={onChangeAmount}
              value={state.amount}
              placeholder="Enter Amount"
            />
          </div>

          <div className="flex flex-col mb-4">
            <label
              htmlFor="payee"
              className="xs:text-xs 5xl:text-lg  text-gray-50_04 text-left mb-2"
            >
              Note
            </label>
            <TextArea onChange={onChangeNote} />
          </div>

          <Button size="default" variant={"primary"}>
            Pay Now
          </Button>
        </form>
      </div>

      {state.isDeviceListModelOpen && (
        <SelectDevice
          showModal={state.isDeviceListModelOpen}
          toggleDeviceList={toggleDeviceList}
          navigateToApproveModal={navigateToApproveModal}
          registrations={mfaPayload?.deviceList || []}
        />
      )}

      {state.isAppoveModelOpen && (
        <ApproveTransaction
          showModal={state.isAppoveModelOpen}
          toggleApprove={toggleApprove}
          transferData={{ ...state, mfaPayload }}
          setStatus={setStatus}
          fromAccount={account?.value}
        />
      )}

      <ResultModal
        showModal={state.isResultModalOpen}
        toggleResultModal={toggleResultModal}
        status={state.approvalStatus}
        transactionId={state.completedTransactionId}
        transferData={TransferDetails}
      />
    </div>
  );
};

export default FundTransferForm;
